export {default as Home} from './home'
export {default as QuizCar} from './quiz-car'
export {default as QuizMot} from './quiz-mot'
export {default as QuizBavyrox} from './quiz-bavyrox'
